module.exports = __webpack_public_path__ + "static/Gotham-Medium-c097925bc86cd4d524fcb4cb3c05b16d.woff2";